module.exports = __webpack_public_path__ + "img/Xicon.4ef65fb.svg";